const DropdownIcon = ({
  size = "small",
  fill = "var(--color-green)",
}: {
  size?: "mini" | "small" | "medium" | "large";
  fill?: string;
}) => {
  const sizeClass = {
    mini: "w-2.5 h-2.5",
    small: "w-3 h-3",
    medium: "w-4 h-4",
    large: "w-8 h-8",
  };

  return (
    <svg
      width="57"
      height="57"
      viewBox="0 0 57 60"
      fill={fill}
      className={`${sizeClass[size]}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M57 16.1C57 15.2733 56.7055 14.4983 56.164 13.9093C55.0525 12.7003 53.2475 12.7003 52.136 13.9093L31.35 36.5187C30.6185 37.3143 29.583 37.769 28.5 37.769C27.417 37.769 26.3815 37.3143 25.65 36.5187L4.864 13.9093C4.313 13.31 3.5815 13 2.85 13C2.1185 13 1.387 13.2997 0.835999 13.9093C0.284999 14.519 0 15.2733 0 16.1C0 16.9267 0.294499 17.7017 0.835999 18.2907L21.622 40.9C23.4555 42.8943 25.9065 44 28.5 44C31.0935 44 33.5445 42.8943 35.378 40.9L56.164 18.2907C56.7055 17.7017 57 16.9267 57 16.1Z" />
    </svg>
  );
};

export default DropdownIcon;
